<div class="bg-lBlack light:bg-lGray950 border border-lGray800 rounded-2xl p-5 h-full flex flex-col gap-4 min-h-0">
  <div class="flex items-center gap-3">
    <span class="w-9 h-9 rounded-xl bg-lGray700 flex items-center justify-center shrink-0">
      <l-icon class="text-lWhite text-lg leading-none">{{ metric.icon }}</l-icon>
    </span>
    <p class="text-color text-base font-semibold leading-snug">{{ metric.title }}</p>
  </div>

  <div class="flex items-center justify-center gap-5 flex-1 min-h-0">
    <img
      src="assets/images/calendar.svg"
      alt=""
      aria-hidden="true"
      class="w-[4.5rem] h-20 object-contain shrink-0"
    />

    <p class="text-color text-3xl font-bold leading-none">{{ metric.value }}</p>
  </div>
</div>
